import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../redux/store';

export const useSpots = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    return {
        dispatch,
        navigate,
        location
    };
};
